import DialogMessage from "@/DialogMessage";
import {useAppVisibility} from "@/hooks/useAppVisibility";
import ActionProvider from "@/providers/ActionProvider";
import ServiceWorkerWrapper from "@/ServiceWorkerWrapper";
import createCache from "@emotion/cache";
import {CacheProvider} from "@emotion/react";
import {GlobalStyles} from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
import React, {Suspense, useEffect} from "react";
import {Helmet, HelmetProvider} from "react-helmet-async";
import {useTranslation} from "react-i18next";
import {QueryClient, QueryClientProvider} from "react-query";
import {useDispatch} from "react-redux";
import {useLocation} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import {prefixer} from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import Loading from "./components/loading/Loading";
import {getProfileInfoApi} from "./core/dashboard/customer/ProfileApi";
import {empty} from "./functions/var/empty";
import {getLang} from "./helper";
import {BLOCK_FETCHING, DOMAIN_NAME, THEME_CSS, USER_INFO} from "./redux/action/type.action";
import {GetState, SetState} from "./redux/reduxhelper";
import {theme} from "./shared/UIElement/theme/Theme";

// Note Create RTL Cache
const cacheRTL = createCache({key: "muirtl", stylesPlugins: [prefixer, rtlPlugin]})
const queryClient = new QueryClient();
const IRoutes = React.lazy(() => import('./AnimatedRoutes'))


function App() {
    const {t, i18n} = useTranslation();
    const dispatch = useDispatch();
    const isVisible = useAppVisibility();

    useEffect(() => {
        let reloadTimer;
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                // اگر بعد از 3 ثانیه از مرئی شدن، اپ هنوز درست نبود
                reloadTimer = setTimeout(() => {
                    // یک فلگ چک کنید که آیا محتوای اصلی رندر شده یا نه
                    const rootElement = document.getElementById('root');
                    if (rootElement && rootElement.innerHTML === '') {
                        window.location.reload();
                    }
                }, 3000);
            } else {
                clearTimeout(reloadTimer);
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
    }, [isVisible]);

    const BlockFetching = () => <Backdrop
        onClick={() => dispatch(SetState(BLOCK_FETCHING, false))}
        open={GetState(BLOCK_FETCHING, false)}
        sx={{zIndex: 2000}}
    >
        <Loading sx={{color: '#a5e757'}}/>
    </Backdrop>

    const pageTitle = GetState(DOMAIN_NAME, null)?.name;
    const currentLang = getLang('fa');
    useEffect(() => {
        i18n?.changeLanguage(currentLang)
        theme.direction = t('dir');
    }, []);

    let themeName = GetState(THEME_CSS, null);
    const setGlobalStyles = (theme) => (
        <GlobalStyles
            styles={{
                ':root': require(`./themes/${themeName}.js`).default,
            }}
        />
    )

    if (empty(themeName)) return <Loading/>

    return (
        <>
            <Suspense fallback={
                <div
                    style={{
                        width: '100vw',
                        height: '100vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        // animation: '1000ms ease-in-out 10ms infinite normal none running rotateIn'
                    }}>
                    <Loading/>
                </div>
            }>
                <ActionProvider>
                    <CacheProvider value={cacheRTL}>
                        <ThemeProvider theme={theme}>
                            {setGlobalStyles(theme)}
                            <HelmetProvider>
                                <Helmet>
                                    <title>
                                        {pageTitle}
                                    </title>
                                </Helmet>
                                {/*<PullToRefresh onRefresh={handleRefresh} />*/}
                                <div className={`App ${theme?.direction}`} dir={theme?.direction}>
                                    <BlockFetching/>
                                    <QueryClientProvider client={queryClient}>
                                        <IRoutes/>
                                        <ToastContainer
                                            style={{left: 0, right: 0, margin: 0}}
                                            bodyStyle={{
                                                direction: theme.direction,
                                                fontSize: 'smaller',
                                                color: '#525252'
                                            }}
                                            // style={{direction:theme.direction, fontSize:'smaller', color:'#00f'}}
                                            // toastStyle={{direction:theme.direction, fontSize:'smaller', color:'#00f'}}
                                        />
                                        {/*<ReactQueryDevtools initialIsOpen={false} />*/}
                                    </QueryClientProvider>
                                    <DialogMessage/>
                                    <ServiceWorkerWrapper/>
                                    {/*<Toaster />*/}
                                </div>
                            </HelmetProvider>
                        </ThemeProvider>
                    </CacheProvider>
                </ActionProvider>
            </Suspense>
        </>
    );
}

export default App;
